module.exports = __webpack_public_path__ + "img/importIcon.ff544f27.svg";